import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import {
  apiAuthenticate,
  apiPostForgotPassword,
  setRoute,
} from "../shared/manager/api_manager";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useLingueStore } from "../sistema/storeLingua";

import "./login.css";

export default function LoginScreen() {
  const { selectedLinguaTesto } = useLingueStore((state) => state);
  const navigate = useNavigate();

  const [usernameStatus, setUsernameStatus] = useState("");
  const [passwordStatus, setPasswordStatus] = useState("");

  const usernameInput = React.useRef();
  const passwordInput = React.useRef();

  const [recoverPwdDialogOpen, setRecoverPwdDialogOpen] = useState(false);

  function handleLogin() {
    console.log("handleLogin");

    if (validateForm()) {
      const username = usernameInput.current.value;
      const password = passwordInput.current.value;

      const authData = {
        emailUtente: username,
        passwordHash: password,
        sysUser: "string",
        sysDate: "2024-05-11T08:35:46.322Z",
        sysAttivo: true,
      };

      //apiAuthenticate(getAPIClient(), authData, apiAuthCallback);
      apiAuthenticate(authData, apiAuthCallback);
    }
  }

  function validateForm() {
    console.log("validateForm");
    let valid = true;
    const username = usernameInput.current.value;
    const password = passwordInput.current.value;
    if (username == null || username == "") {
      valid = false;
      setUsernameStatus(" notvalid");
    } else {
      setUsernameStatus("");
    }

    if (password == null || password == "") {
      valid = false;
      setPasswordStatus(" notvalid");
    } else {
      setPasswordStatus("");
    }

    return valid;
  }

  function apiAuthCallback(response, guard) {
    console.log(response);
    if (response != null && response.status >= 200 && response.status < 400) {
      setRoute(guard);
      navigate("/avp");
    } else {
      console.error("apiAuthCallback");
    }
  }

  function handlePasswordLost() {
    console.log("handlePasswordLost");

    let username = usernameInput.current.value;
    if (username == null || username == "") {
      setUsernameStatus(" notvalid");
    } else {
      setUsernameStatus("");

      let body = {
        emailUtente: username,
        sysUser: "",
        sysDate: new Date().toISOString(),
        sysAttivo: true,
      };
      apiPostForgotPassword(body, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          setRecoverPwdDialogOpen(true);
        }
      });
    }
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      handleLogin();
    }
  }

  const handleDialogClose = () => {
    setRecoverPwdDialogOpen(false);
  };

  return (
    <div id="avp-login-screen">
      <div id="avp-login-screen-content">
        <div id="avp-login-screen-body-header">
          <div id="avp-login-screen-body-header-title">
            {selectedLinguaTesto?.LoginHeaderTitle}
          </div>
          <div id="avp-login-screen-body-header-subtitle">
            {selectedLinguaTesto?.LoginHeaderSubtitle}
          </div>
        </div>
        <div className="avp-login-form-container">
          <div className="avp-login-form">
            <div className="avp-login-form-title">
              {selectedLinguaTesto?.LoginFormTitle}
            </div>

            <div className="avp-login-form-content">
              <div className="avp-login-elemento">
                <label className="avp-login-label" htmlFor="avp-login-username">
                  {selectedLinguaTesto?.LoginFormLableUsername}
                </label>
                <input
                  className={"avp-login-input" + usernameStatus}
                  type="text"
                  id="avp-login-username"
                  ref={usernameInput}
                />
              </div>

              <div className="avp-login-elemento">
                <label className="avp-login-label" htmlFor="avp-login-password">
                  {selectedLinguaTesto?.LoginFormLablePassword}
                </label>
                <input
                  className={"avp-login-input" + passwordStatus}
                  type="password"
                  id="avp-login-password"
                  ref={passwordInput}
                  onKeyDown={handleKeyDown}
                />
              </div>

              <div id="avp-login-errore" className="avp-login-elemento"></div>

              <div className="avp-login-elemento" id="avp-login-passwordlost">
                <a
                  className="avp-login-password-dimenticata"
                  onClick={() => handlePasswordLost()}
                >
                  {selectedLinguaTesto?.LoginFormLablePasswordDimenticata}
                </a>
              </div>

              <div className="avp-login-elemento">
                <button
                  className="avp-login-button"
                  onClick={() => handleLogin()}
                >
                  {selectedLinguaTesto?.LoginFormButtonLogin}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={recoverPwdDialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Recupero password"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.LoginDialog}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} autoFocus>
            {selectedLinguaTesto?.LoginDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
